import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Create/Manage Bundle",
        defaultMessage: "Create/Manage Bundle"
    },
    issueChanges: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Issue Changes",
        defaultMessage: "Issue Changes"
    },
    requote: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Requote",
        defaultMessage: "Requote"
    },
    cancel: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Cancel",
        defaultMessage: "Cancel"
    },
    invalidBundleError: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Invalid Bundle Msg",
        defaultMessage: "Bundle must contain 2 or more policies. Uncheck to unbundle all policies or recheck at least 1 more policy to continue."
    },
    anyPolicyWithPendingChangesError: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Cannot requote as one of the policies",
        defaultMessage: "Cannot requote as one of the policies has a pending change. Please complete or remove existing change to proceed."
    },
    bundleModified: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.You modified your bundle",
        defaultMessage: "You modified your bundle, check the updated prices."
    },
    confirmChanges: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.If you want to confirm changes",
        defaultMessage: "If you want to confirm changes click 'Issue Changes', otherwise click 'Cancel'."
    },
    effectiveDate: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Effective Date",
        defaultMessage: "Effective Date"
    },
    changeDate: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Change Date",
        defaultMessage: "Change Date"
    },
    policyType: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Policy Type",
        defaultMessage: "Policy Type"
    },
    producerCode: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Producer Code",
        defaultMessage: "Producer Code"
    },
    offering: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Offering",
        defaultMessage: "Offering"
    },
    policyNumber: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Policy #",
        defaultMessage: "Policy #"
    },
    bundled: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Bundled",
        defaultMessage: "Bundled"
    },
    previous: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Previous",
        defaultMessage: "Previous"
    },
    new: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.New",
        defaultMessage: "New"
    },
    proRata: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Pro Rata",
        defaultMessage: "Pro Rata"
    },
    premium: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Premium",
        defaultMessage: "Premium"
    },
    total: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Total",
        defaultMessage: "Total"
    },
    notEligible: {
        id: "endorsement.common.views.ml-manage-bundle-dialog.Not Eligible",
        defaultMessage: "Not Eligible"
    },
});
